import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const BRILLO_LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_51bffd07-aa4d-4a7d-95f9-f89bd7c79be4/artifacts/sizi23p9_Brillo%20Finance%20Without%20Slogan-2.png";

export const WHATSAPP_NUMBER = "523344065965";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hola Brillo Finance, quiero información sobre crédito hipotecario."
)}`;

export const CREDITARIA_URL =
  "https://preca.creditaria.app/?utm_id=lead-capture-mx-1";

/* Premium form options */
export const TIPO_OPERACION_OPTIONS = [
  { value: "adquisicion", label: "Adquisición" },
  { value: "construccion_remodelacion", label: "Construcción y Remodelación" },
  { value: "sustitucion", label: "Sustitución" },
  { value: "liquidez", label: "Liquidez" },
];

export const VALOR_OPERACION_OPTIONS = [
  { value: "7.5m_10m", label: "De $7.5M a $10M" },
  { value: "10m_15m", label: "De $10M a $15M" },
  { value: "15m_20m", label: "De $15M a $20M" },
  { value: "20m_30m", label: "De $20M a $30M" },
  { value: "30m_45m", label: "De $30M a $45M" },
  { value: "mas_45m", label: "Más de $45M" },
];

/* Legacy options — kept for admin backward compat with old leads */
export const TIPO_CREDITO_OPTIONS = [
  { value: "adquisicion", label: "Adquisición" },
  { value: "construccion", label: "Construcción" },
  { value: "sustitucion", label: "Sustitución de hipoteca" },
  { value: "liquidez", label: "Liquidez" },
];

export const INGRESOS_OPTIONS = [
  { value: "empleado", label: "Empleado" },
  { value: "negocio_propio", label: "Negocio propio" },
  { value: "informal", label: "Informal" },
  { value: "sin_comprobar", label: "Sin comprobar" },
];

export const labelOf = (opts, val) =>
  opts.find((o) => o.value === val)?.label || val;
